const MAP_HOSTNAME = "map.neighborhoodexplorer.org";
const STAGING_HOSTNAME = "neighborhood-explorer-staging.herokuapp.com";
const DISABLE_REDIRECT_PARAM = "dwft_disable_homepage_redirect";
const RESCUE_ATTEMPT_KEY = "ne.stagingRedirectRescueAttempted";

const readSessionFlag = (storage: Storage | null): boolean => {
  try {
    return storage?.getItem(RESCUE_ATTEMPT_KEY) === "1";
  } catch {
    return false;
  }
};

const writeSessionFlag = (storage: Storage | null): void => {
  try {
    storage?.setItem(RESCUE_ATTEMPT_KEY, "1");
  } catch {
    // The disable query flag below is the fallback loop guard if storage is unavailable.
  }
};

export const buildStagingRedirectRescueUrl = (referrer: string): string | null => {
  if (!referrer) return null;

  try {
    const url = new URL(referrer);
    if (url.hostname.toLowerCase() !== STAGING_HOSTNAME) return null;
    if (url.searchParams.get(DISABLE_REDIRECT_PARAM) === "1") return null;
    url.searchParams.set(DISABLE_REDIRECT_PARAM, "1");
    return url.toString();
  } catch {
    return null;
  }
};

export const rescueStagingHomepageRedirect = (): boolean => {
  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname.toLowerCase();
  if (hostname !== MAP_HOSTNAME) return false;
  if (readSessionFlag(window.sessionStorage)) return false;

  const rescueUrl = buildStagingRedirectRescueUrl(document.referrer);
  if (!rescueUrl) return false;

  writeSessionFlag(window.sessionStorage);
  window.location.replace(rescueUrl);
  return true;
};
